import { Button } from '@/components/ui/button';
import { useGetPlantQuery } from '@/features/plants/hooks/queries/[plantId]/use-get-plant';
import { useMediaQuery } from '@/hooks/use-media-query';
import { ChevronLeft } from 'lucide-react';
import { Link, useParams } from 'react-router';
import MyProfileAvatar from '@/components/my-profile-avatar.tsx';
import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import { Skeleton } from '@/components/ui/skeleton';
import PlantUptimeStatusPopover from '@/features/plants/components/plant-monitoring/plant-uptime-status-popover';
import { FileTab } from '@/features/plants/components/plant-schedule/file-tab/file-tab.tsx';
import { PlantScheduleBreadcrumbs } from '@/features/plants/components/plant-schedule/plant-schedule-breadcrumbs.tsx';
import { useGetSchedulesPlantQuery } from '@/features/plants/hooks/queries/[plantId]/schedule/use-get-schedules.ts';
import { PlantMenuPopover } from '@/features/plants/components/plant-overview/plant-menu-popover';

export const SchedulePlantPage = () => {
  const { plantId } = useParams();
  const isMobile = useMediaQuery('(max-width:640px)');

  const { data: plant, isLoading: isPlantLoading } = useGetPlantQuery({
    plantId: plantId || '',
  });

  const { data: schedules, isLoading: isPlantSchedulesLoading } = useGetSchedulesPlantQuery({
    plantId,
  });

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          {!isMobile ? (
            <PlantScheduleBreadcrumbs
              plantName={plant?.basicDetails.name || ''}
              plantId={plantId || ''}
              isMobile={isMobile}
            />
          ) : (
            <Button variant="outline" asChild className="size-8 p-0">
              <Link to="/plants">
                <ChevronLeft />
              </Link>
            </Button>
          )}

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {isPlantLoading ? (
            <Skeleton className="h-8 w-32" />
          ) : (
            <div className="flex w-full justify-between">
              <h2 className="text-2xl font-semibold">{plant?.basicDetails.name}</h2>
              <div className="flex items-center gap-2">
                <PlantUptimeStatusPopover />
                <PlantMenuPopover isLoading={isPlantLoading} />
              </div>
            </div>
          )}

          <div className="relative flex w-full max-w-[1596px] overflow-hidden">
            <FileTab
              plantId={plantId}
              initialSchedules={schedules}
              isLoading={isPlantSchedulesLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePlantPage;
